import { Flex, Spinner } from "@chakra-ui/react";
import { TotalCard } from "./components/total-card";
import { FeesChart } from "./components/fees-chart";
import { PaymentStatusChart } from "./components/payment-status-chart";
import PageHeader from "components/layout/PageHeader";
import { useRevenue } from "./hooks/use-revenue";

export function Revenue() {
	const { data, isLoading } = useRevenue();

	return (
		<>
			<PageHeader title="Revenue" />

			{isLoading() ? (
				<Spinner />
			) : (
				<Flex direction="column" gap={6}>
					<Flex direction="row" gap={6}>
						{data.totals.map((total) => (
							<TotalCard
								key={total.title}
								title={total.title}
								value={total.value}
								percentageInLastMonth={total.percentageInLastMonth}
								flex="1"
							/>
						))}
					</Flex>
					<Flex direction="row" gap={6}>
						{data.fees.lienTypes.map((lienType) => (
							<FeesChart
								key={lienType.title}
								title={lienType.title}
								data={lienType.data}
								flex="1"
							/>
						))}
					</Flex>
					<Flex direction="row" gap={6}>
						<PaymentStatusChart chart={data.paymentStatus} flex="1" />
					</Flex>
				</Flex>
			)}
		</>
	);
}
